import { sanitize } from '@cigna/dcws_leaf-web-components/utilities/sanitize.js';
import type { submittedData } from '../interface.js';

export const contactus = async (endpoint: string, dataSubmitted: submittedData) => {
  const controller = new AbortController();
  const terminateEarly = setTimeout(() => controller.abort(), 10000);

  const data = {
    source: 'cigna.com',
    customerInformation: {
      gender: 'U',
      firstName: dataSubmitted.firstName,
      lastName: dataSubmitted.lastName,
      phone: dataSubmitted.phone.replace('+', ''),
    },
    identifiers: {
      campaignId: '0006734',
    },
    customInformation: [
      {
        name: 'LangPref',
        value: dataSubmitted.langpref,
      },
    ],
  };

  const response = await fetch(endpoint, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: sanitize(JSON.stringify(data)),
  });
  clearTimeout(terminateEarly);
  if (!response.ok) {
    throw new Error('Connect us form - response was not OK');
  } else {
    return 200;
  }
};

export default contactus;
